import { Flex, Box, Icon } from "@chakra-ui/react";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { FiMail, FiFacebook, FiTwitter, FiLinkedin } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { RiTelegramLine } from "react-icons/ri";

export function Share({ url, title }) {
  return (
    <Flex justifyContent="space-evenly" my={4}>
      <Box border="1px" borderRadius="md" padding={2}>
        {/* ToDo Add the realsite link */}
        <WhatsappShareButton url={`https://google.com${url}`} subject={title}>
          <Icon as={FaWhatsapp} boxSize={8} mx={2} />
        </WhatsappShareButton>
        <TelegramShareButton url={url} subject={title}>
          <Icon as={RiTelegramLine} boxSize={8} mx={2} />
        </TelegramShareButton>
        <TwitterShareButton url={url} subject={title}>
          <Icon as={FiTwitter} boxSize={8} mx={2} />
        </TwitterShareButton>
        <LinkedinShareButton url={url} subject={title}>
          <Icon as={FiLinkedin} boxSize={8} mx={2} />
        </LinkedinShareButton>
        <EmailShareButton url={url} subject={title}>
          <Icon as={FiMail} boxSize={8} mx={2} />
        </EmailShareButton>
        <FacebookShareButton url={url} subject={title}>
          <Icon as={FiFacebook} boxSize={8} mx={1} />
        </FacebookShareButton>
      </Box>
    </Flex>
  );
}
